import {checkQuest, fetchQuests} from '@/shared/api/api';
import {makeAutoObservable, runInAction} from 'mobx';
import {RootStore} from "@/app/providers/StoreProvider";
import {IQuestCheck, Quest} from "@/entities/quest/types";

export class QuestStore {

    constructor(private rootStore: RootStore) {
        makeAutoObservable(this);
    }

    private get errorStore() {
        return this.rootStore.errorStore;
    }

    quests: Quest = {};
    loading: boolean = false;

    getQuests = async () => {
        this.loading = true;
        try {
            const quests = await fetchQuests();
            if (quests.success) {
                runInAction(() => {
                    this.quests = quests.data;
                });
            } else {
                this.errorStore.setError(quests.error)
            }
        } finally {
            runInAction(() => {
                this.loading = false;
            });
        }
    }


    checkQuests = async (payload: IQuestCheck) => {
        this.loading = true;
        let request =  null;
        try {
            const quests = await checkQuest(payload);
            if (quests.success) {
                runInAction(() => {
                    request = quests.data;
                });
            } else {
                this.errorStore.setError(quests.error)
            }
        } finally {
            runInAction(() => {
                this.loading = false;
            });
        }

        return request;
    }

}
